import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Applications } from './Applications'
import { Featured } from './Featured'
import { Positions } from './Positions'
import { JobsProps } from './types'

export const Jobs: FC<JobsProps> = ({ seo, content, header, footer }) => {
  const {
    breadcrumb,
    title,
    subtitle,
    description,
    button_label,
    button_link,
    video_link,
    warning,
    positions,
    application,
    helper,
    job_name,
    workplace,
    workfield
  } = content

  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured
        breadcrumb={breadcrumb}
        title={title}
        subtitle={subtitle}
        description={description}
        button_label={button_label}
        button_link={button_link}
        video_link={video_link}
      />
      <Positions
        warning={warning}
        positions={positions}
        job_name={job_name}
        workfield={workfield}
        workplace={workplace}
      />
      <Applications application={application} helper={helper} />
    </Page>
  )
}
